export default{

    chosenBets : []
}